import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file withSelectTrigger
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useUpdate } from '@tencent/glue-react-use';
import { useEffect } from 'react';
import { useSelectDisplayInfo } from '@tencent/glue-react-select';
import { useClickTrigger } from '@tencent/glue-react-popper';
export function SelectClickTrigger(props) {
  var show = props.show,
      triggerId = props.triggerId,
      disabled = props.disabled,
      renderTrigger = props.renderTrigger;
  var update = useUpdate();
  useEffect(function () {
    // 初始化需要收集option的信息，displayInfo获取可能不全，didMount刷新一下组件，重新更新
    update();
  }, []);
  var displayInfo = useSelectDisplayInfo();

  var _useClickTrigger = useClickTrigger({
    disabled: disabled
  }, {}, triggerId),
      _useClickTrigger2 = _slicedToArray(_useClickTrigger, 1),
      ref = _useClickTrigger2[0];

  return renderTrigger ? renderTrigger(ref, show, displayInfo) : null;
}